module.exports = __webpack_public_path__ + "static/media/penguin_tex.e26058e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/penguin/penguin_tex.png
// module id = 135
// module chunks = 0